import * as React from 'react';
import styled from '@emotion/styled';

const InputBase = styled.input<{ width?: string }>`
  border: 1px solid #33322f;
  padding: 16px 12px;
  background-color: #ffffff;
  width: ${(props) => (props.width ? props.width : '230px')};
`;
const InputBorderless = styled(InputBase)`
  background-color: #f9f8f7;
  border: 1px solid #f9f8f7;
  :focus{
    border:1px solid #f9f8f7;
    outline: 1px solid #f9f8f7;
  }
`;
const InputError = styled(InputBase)`
  border: 1px solid #c50e29;
`;
const IconStyles = styled.div`
  position: absolute;
  right: 24px;
  top: 0px;
  cursor: pointer;
`;
const LabelText = styled.div<{ isColor?: boolean }>`
  padding-bottom: 4px;
  color: ${(props) => (props.isColor && '#C50E29')};
`;
const BottomText = styled.div<{ isColor?: boolean }>`
  padding-Top: 4px;
  color: ${(props) => (props.isColor && '#C50E29')};
`;
interface Props {
  width?: string;
  isColor?: boolean;
  isBottomText?: boolean;
  bottomText?: string;
  icon?: any;
  isPassword?: boolean;
  topText?: string;
  inputType?: 'InputBorderless' | 'InputError';
  onChange: (e: any) => void;
  value: string;
  isLabel?: boolean;
  labelText?: string;
  [key: string]: any;
}
const Input = (props: Props | any) => {
  const GetInput = () => {
    switch (props.inputType) {
      case 'InputBorderless':
        return (
          <>
            {props.isLabel && <LabelText isColor={props.isColor}>{props.labelText}</LabelText>}
            <label style={{ position: 'relative' }}>
              <InputBorderless {...props} value={props.value} onChange={props.onChange}/>
              <IconStyles>{props.icon}</IconStyles>
            </label>
            {props.isBottomText && <BottomText isColor={props.isColor}>{props.bottomText}</BottomText>}
          </>
        );
      case 'InputError':
        return (
          <>
            {props.isLabel && <LabelText isColor={props.isColor}>{props.labelText}</LabelText>}
            <label style={{ position: 'relative' }}>
              <InputError {...props} value={props.value} onChange={props.onChange}/>
              <IconStyles>{props.icon}</IconStyles>
            </label>
            {props.isBottomText && <BottomText isColor={props.isColor}>{props.bottomText}</BottomText>}
          </>
        );
      default:
        return (
          <>
            {props.isLabel && <LabelText isColor={props.isColor}>{props.labelText}</LabelText>}
            <label style={{ position: 'relative' }}>
              <InputBase {...props} value={props.value} onChange={props.onChange}/>
              <IconStyles>{props.icon}</IconStyles>
            </label>
            {props.isBottomText && <BottomText isColor={props.isColor}>{props.bottomText}</BottomText>}
          </>
        );
    }
  };
  return GetInput();
};

export default Input;
